import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useToast,
} from '@chakra-ui/react';
import { useRemoveOrgMemberMutation } from '../../Services/orgApi';

const RemoveMemberModal = ({
  isOpen, onClose, memberEmail, accountId,
}) => {
  const [removeMember, { isLoading }] = useRemoveOrgMemberMutation();
  const toast = useToast();

  const handleRemove = async () => {
    if (!accountId || !memberEmail) return;
    await removeMember({ accountId, email: memberEmail }).unwrap();
    toast({
      title: 'Member removed',
      description: `${memberEmail} no longer has access to this organization`,
      status: 'success',
      variant: 'left-accent',
      isClosable: true,
      position: 'top',
      duration: 3000,
    });
    onClose();
  };

  if (!isOpen || !memberEmail) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Remove member</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          Remove
          {' '}
          <b>{memberEmail}</b>
          {' '}
          from this organization? They will lose access immediately.
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" isDisabled={isLoading} onClick={onClose}>
            Cancel
          </Button>
          <Button
            colorScheme="red"
            ml={3}
            onClick={handleRemove}
            isLoading={isLoading}
          >
            Remove
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default RemoveMemberModal;
